import { createElement } from "./PluginCustomProgress";
import intl from "react-intl-universal";
import {
  getToMiniProgramDownloadUrl,
  isInMiniProgram,
} from "../../utils/mini_program";
import imageUtil from "../../utils/image";

const { downloadImage } = imageUtil;

export default class PluginMiniProgramDownload {
  el = null as any;
  player = null as any;
  videoUrl = "";
  videoId = 0;
  constructor(videoUrl: string, videoId: number) {
    this.videoUrl = videoUrl;
    this.videoId = videoId;
  }
  createEl(el: any, player: any) {
    this.el = el;
    this.player = player;
    const downloadName = intl.get("Download-Pendent");
    const controlBar = this.el.querySelector(".prism-controlbar");
    const download = createElement("div", { className: "download-btn" });
    const downloadUrl = getToMiniProgramDownloadUrl(
      [{ id: this.videoId, url: this.videoUrl }],
      "video"
    );
    const isMiniProgram = isInMiniProgram();
    if (isMiniProgram) {
      const { miniProgram } = window.wx || {};
      download.onclick = function () {
        console.log("clicked, prepare to mini program", downloadUrl);
        miniProgram && miniProgram.navigateTo({ url: `/${downloadUrl}` });
      };
      download.innerHTML = `
        <div style="text-align: center;color:#fff;font-size:12px;">${downloadName}</div>
      `;
    } else {
      // 这个按钮样式不好调， 请将就一下咯，不知道为啥script里边会认为他的宽度被外层限制了，所以外层没有宽度会导致里边的宽度为0的样子
      // 如果是微信的网页环境
      if (window.isweixin || window.isweixinweb) {
        download.innerHTML = `
          <wx-open-launch-weapp
              id="launch-btn"
              username="gh_e97c78460d68"
              path='${downloadUrl}'
              style='width: 40px'
            ><script type="text/wxtag-template"><div style="text-align: center;color:#fff;font-size:12px;">${downloadName}</div></script></wx-open-launch-weapp>`;
      } else {
        download.onclick = () => {
          downloadImage(this.videoUrl, `${this.videoId}.mp4`);
        };
        download.innerHTML = downloadName;
      }
    }

    controlBar.append(download);
  }
}
